import styled from 'styled-components';

export const ChangeVehicleComponentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    flex: 1 1 auto;
    .change-vehicle-title {
        display: none;
    }
    [data-testid='btn-cancel-change-vehicle'] {
        display: none;
    }

    /* In the Showroom context the footer should flow with the content card
       instead of being fixed to the viewport bottom. */
    .change-vehicle-container {
        padding: 0;
    }

    .change-vehicle-container .change-vehicle-footer {
        position: static;
        left: auto;
        right: auto;
        bottom: auto;
        margin-top: auto;
    }

    .change-vehicle-container .change-vehicle-footer,
    .change-vehicle-footer-grid {
        background-color: transparent;
    }
    .change-vehicle-footer-grid {
        padding: 30px 0 10px 0;
    }

    /* The library reserves space for the fixed footer; remove it since the
       footer now flows inline within the content. Stretch the container to
       fill the available height so the footer sits at the bottom. The library
       also pushes the content down with top: 40px - reset it to remove the
       large gap at the top. */

    /* The direct child is the library's StyledChangeVehicleActivity wrapper.
       It must also stretch so the inner flex height chain works. */
    & > div {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
    }

    .activities-change-vehicle {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
    }

    .change-vehicle-container {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        width: 100%;
        top: 0;
        margin-bottom: 0;
        padding-bottom: 0;
    }

    /* Let the search/select area grow to absorb the remaining space so the
       footer is pinned to the bottom of the card. */
    [class*='SearchAndSelectVehicleContainerWrapper'] {
        flex: 1 1 auto;
    }
`;
